import { DateToUnixConverter } from "common/DateConverter";
import { dataInterval } from "common/types";
import moment from "moment";
import {
  PeriodType,
  IUnixTimeObject,
  IDateHandlerObject,
  IInstallationDataResult,
  DataTypes,
} from "nodeDetails/types";
import {
  capitalizeFirstLetter,
  getDataIntervalOnString,
} from "./dataFunctions";
import { getPeriodType } from "./dateFunctions";
import { t } from "i18next";

export const changeMeter = (
  selectedPeriod: PeriodType,
  dateHandler: IDateHandlerObject
) => {
  const period = {
    period: selectedPeriod,
    from: DateToUnixConverter(dateHandler.from),
    to: DateToUnixConverter(dateHandler.to),
  };
  return period;
};

export const changePeriod = (dateHandlerObj: IDateHandlerObject) => {
  const period: IUnixTimeObject = {
    period: getPeriodType(dateHandlerObj.period),
    from: DateToUnixConverter(dateHandlerObj.from),
    to: DateToUnixConverter(dateHandlerObj.to),
  };
  return period;
};

export const changeInterval = (newPeriod: string) => {
  const interval: dataInterval = getDataIntervalOnString(newPeriod);
  const periodType: PeriodType = getPeriodType(newPeriod);
  const date = moment();
  const from = DateToUnixConverter(
    date.date() === 1
      ? date.subtract(1, periodType).startOf(periodType)
      : date.startOf(periodType)
  );
  const to = DateToUnixConverter(moment.unix(from).endOf(periodType));
  const unixTimeObject: IUnixTimeObject = {
    period: periodType,
    from: from,
    to: to,
  };
  return {
    from: from,
    to: to,
    interval: interval,
    periodType: periodType,
    unixTimeObject: unixTimeObject,
  };
};

export const updateDataset = (
  dataset: string,
  data: IInstallationDataResult[],
  currency: string,
  previousData?: IInstallationDataResult[]
) => {
  const [currentCon, currentPrice, currentCo2] = data;
  if (previousData) {
    const [previousCon, previousPrice, previousCo2] = previousData;
    if (dataset === currency || dataset === "price") {
      return {
        currentData: currentPrice,
        prevData: previousPrice,
      };
    }
    if (dataset === "CO2e" || dataset === "co2") {
      return {
        currentData: currentCo2,
        prevData: previousCo2,
      };
    }
    if (dataset === t("Units")) {
      return {
        currentData: currentCon,
        prevData: previousCon,
      };
    }
    if (dataset === "con" || capitalizeFirstLetter(data[0].Unit)) {
      return {
        currentData: currentCon,
        prevData: previousCon,
      };
    }
  } else {
    if (dataset === currency || dataset === "price") {
      return {
        currentData: currentPrice,
        prevData: undefined,
      };
    }
    if (dataset === "CO2e" || dataset === "co2") {
      return {
        currentData: currentCo2,
        prevData: undefined,
      };
    }
    if (dataset === t("Units")) {
      return {
        currentData: currentCon,
        prevData: undefined,
      };
    }
    if (dataset === "con") {
      return {
        currentData: currentCon,
        prevData: undefined,
      };
    }
  }
  return {
    currentData: currentCon,
    prevData: undefined,
  };
};

export const getDataType = (dataFunc: string) => {
  switch (dataFunc) {
    case "price":
      return DataTypes.Price;
    case "co2":
      return DataTypes.Co2;
    case "con":
      return DataTypes.Consumption;
    default:
      return DataTypes.Consumption;
  }
};

export const getDatasetInitialValue = (
  data: IInstallationDataResult[] | undefined,
  avaliableDatasets: string[],
  selectedDataType: DataTypes,
  currency: string | undefined
) => {
  if (avaliableDatasets.length < 1 || !data || !data[selectedDataType])
    return "";
  if (data[selectedDataType].Func === "price") return currency ? currency : "";
  if (data[selectedDataType].Func === "co2") return "CO2e";
  if (data[selectedDataType].Func === "val") return "dls";
  if (data[selectedDataType].Utl === "HCA") return t("Units");
  if (data[selectedDataType].Utl === "HCAE") return t("Units");
  return capitalizeFirstLetter(data[selectedDataType].Unit);
};
